import carIcon from "../../assets/icons/Car.svg";
import bikeIcon from "../../assets/icons/bike.svg";
import bicycleIcon from "../../assets/icons/Bicycle.svg";

export const STATUSES = {
  UNASSIGNED: { color: "INFO_BLUE" },
  ON_HOLD: { color: "MINSK" },
  ASSIGNED: { color: "MINSK" },
  READY_TO_DISPATCH: { color: "READY_BLUE" },
  OUT_FOR_DELIVERY: { color: "PRIMARY_BLUE" },
  DELIVERED: { color: "JUNGLE_GREEN" },
  PARTIALLY_DELIVERED: { color: "PARTIAL_SUCCESS_GREEN" },
  DELIVERY_ATTEMPTED: { color: "ALERT_ORANGE" },
  CANCELLED_BY_SOURCE: { color: "PALE_GRAY" },
  DELIVERY_FAILED: { color: "ERROR_RED" },
  PACKING_COMPLETE: { color: "MINSK" },
  PICKED_UP: { color: "EMRALD" }
} as const;

export const DRIVER_STATUSES = {
  ACTIVE: {
    color: "OCEAN_GREEN",
    hintText: "",
    value: "ACTIVE",
  },
  AVAILABLE: {
    color: "SEA_GREEN",
    hintText: "",
    value: "AVAILABLE",
  },
  UNASSIGNED: {
    color: "SEA_GREEN",
    hintText: "",
    value: "UNASSIGNED",
  },
  ASSIGNED: {
    color: "ASSIGNED_LIGHT_BLUE",
    hintText: "",
    value: "ASSIGNED",
  },
  BACK_TO_STORE: {
    color: "STORE_BROWN",
    hintText: "",
    value: "BACK_TO_STORE",
  },
  AWAY: {
    color: "AMARANTH",
    hintText: "",
    value: "AWAY",
  },
  OUT_FOR_DELIVERY: {
    color: "DELIVARY_ORANGE",
    hintText: "",
    value: "OUT_FOR_DELIVERY",
  },
  OFFLINE: {
    color: "PALE_GRAY",
    hintText: "",
    value: "OFFLINE",
  },
  "OUT FOR DELIVERY": {
    color: "DELIVARY_ORANGE",
    hintText: "",
    value: "OUT_FOR_DELIVERY",
  },
  "BACK TO STORE": {
    color: "STORE_BROWN",
    hintText: "",
    value: "BACK_TO_STORE",
  },
} as const;

export const ORDER_STATUSES = {
  READY: {
    color: "INFO_BLUE",
  },
  EXPORTED: {
    color: "READY_BLUE",
  },
  READY_TO_DISPATCH: {
    color: "READY_BLUE",
  },
  PAYMENT_ACCEPTED: {
    color: "MINSK_DARK",
  },
  DISPATCHED: {
    color: "SCAMPI",
  },
  DELIVERY_ATTEMPTED: {
    color: "DRIFT_WOOD",
  },
  OUT_FOR_DELIVERY: {
    color: "TAG_YEllOW",
  },
  DELIVERED: {
    color: "PERSIAN_GREEN_DARK",
  },
  PARTIALLY_DELIVERED: {
    color: "PARTIAL_SUCCESS_GREEN",
  },
  CANCELLED: {
    color: "SILVER_CHALICE2",
  },
  DELIVERY_FAILED: {
    color: "PALE_RED",
  },
  PACKING_COMPLETE: {
    color: "GREEN_BLUE",
  },
  PICKING_STARTED: {
    color: "MAROON",
  },
  PICKED_UP: {
    color: "EMRALD",
  },
} as const;

export const ORDER_STATUS = {
  READY: "READY",
  EXPORTED: "EXPORTED",
  READY_TO_DISPATCH: "READY_TO_DISPATCH",
  PAYMENT_ACCEPTED: "PAYMENT_ACCEPTED",
  DISPATCHED: "DISPATCHED",
  DELIVERY_ATTEMPTED: "DELIVERY_ATTEMPTED",
  OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
  DELIVERED: "DELIVERED",
  PARTIALLY_DELIVERED: "PARTIALLY_DELIVERED",
  CANCELLED: "CANCELLED",
  DELIVERY_FAILED: "DELIVERY_FAILED",
  PACKING_COMPLETE: "PACKING_COMPLETE",
  PICKING_STARTED: "PICKING_STARTED",
} as const;

export const FILTER_CHIPS = [
  {
    code: "UNASSIGNED",
    value: "Unassigned",
  },
  {
    code: "ON_HOLD",
    value: "On Hold",
  },
  {
    code: "ASSIGNED",
    value: "Assigned",
  },
  {
    code: "OUT_FOR_DELIVERY",
    value: "Out For Delivery",
  },
  {
    code: "COMPLETED",
    value: "Completed",
  },
  {
    code: "ALL",
    value: "All",
  },
];
export const NON_EDITABLE_STATUSES = [
  "DELIVERY_FAILED",
  "CANCELLED_BY_SOURCE",
  "PARTIALLY_DELIVERED",
  "DELIVERED",
];
export const DEFAULT_FILTER_CHIP = "UNASSIGNED";
export const ALL_FILTER_CHIP = "ALL";
export const DELIVERY_EXECUTION_STATUS = {
  DELAYED: {
    color: "ORANGE",
  },
  ON_TIME: {
    color: "SUCCESS_GREEN",
  },
};
export const REFRESHABLE_STATUSES = ["READY", "EXPORTED", "PICKING_STARTED"];
export const DRIVER_ASSIGNED_SUCCESS_MSG = "Driver Assigned successfully";
export const DEFAULT_STATUS_SELECTION = "DELIVERED";
export const PARTIALLY_DELIVERED = "PARTIALLY_DELIVERED";
export const CLUBBED_RESTRICTED_STATUSES = ["READY", "EXPORTED", "PICKING_STARTED"];
export const REPLANNING_CONSIGNMENT_SUCCESS_MSG =
  "Consignment updated successfully.";
export const ADDRESS_MARKED_UNVERIFIED =
  "Address has been marked as unverified";

export const DELIVERY_TYPE = {
  DISPATCHER: "DELIVERY_DISPATCHER",
  LINE_ITEM_REJECTION: "LINE_ITEM_REJECTION",
  ON_HOLD: "ONHOLD_DISPATCHER",
  ORDER_COMMENTS: "ORDER_COMMENTS",
  DELIVERY_COMPLETE_DISPATCHER: "DELIVERY_COMPLETE_DISPATCHER",
};
export const DRIVERS_CATEGORY = {
  ASSIGNED: "ASSIGNED",
  UNASSIGNED: "UNASSIGNED",
  OTHERS: "OTHERS",
};
export const DRIVER_STATUS = {
  OUT_FOR_DELIVERY: "Out For Delivery",
};
export const VEHICLE_TYPE = {
  CAR: "CAR",
  BIKE: "BIKE",
  BICYCLE: "BICYCLE",
};
export const RESPONSE_CONSTANTS = {
  ERROR_CODES: {
    SESSION_TIMEOUT: "UM100",
    UNAUTHORISED: "UM101",
    CONCURRENT_CONSIGNMENT: "CWO15",
  },
};
export const ORDER_LOG_MODIFIED_BY = {
  MANUAL: "Manual",
  SYSTEM: "System",
};

export const DRIVER_SHARED_CONSTANTS = {
  DELIVERY_TYPE,
  DRIVERS_CATEGORY,
  DRIVER_STATUS,
  VEHICLE_TYPE,
  RESPONSE_CONSTANTS,
  ORDER_LOG_MODIFIED_BY,
};

// Centralized mapping for vehicle types
export const vehicleTypeMapping: Record<string, { icon: string; alt: string }> = {
  BIKE: { icon: bikeIcon, alt: "bike" },
  CAR: { icon: carIcon, alt: "car" },
  BICYCLE: { icon: bicycleIcon, alt: "bicycle" },
  DEFAULT: { icon: carIcon, alt: "vehicle" }, // Default fallback
};
